import { IDataLogin, IUser } from '@core/api-types/user';
import { createReducer, on, createFeature } from '@ngrx/store';
import { authActions } from './auth.actions';

export interface AuthState {
    loggedIn: boolean;
    user: IDataLogin;
    status: Status;
}

export enum Status {
    INIT = 'INIT',
    IN_PROGRESS = 'IN_PROGRESS',
    FAIL = 'FAIL'
}

export const authInitialState: AuthState = {
    loggedIn: false,
    status: Status.INIT,
    user: {} as IDataLogin,
};

export const authFeature = createReducer(
    authInitialState,
    on(authActions.getusersuccess, (state, action) => ({
        ...state,
        loggedIn: true,
        user: action.user,
    })),
    on(authActions.getuserfailure, authActions.logout, () => authInitialState),
    on(authActions.login, authActions.register, (state) => {
        return {
            ...state,
            status: Status.IN_PROGRESS,
        };
    }),
    on(
        authActions.registersuccess,
        authActions.loginsuccess,
        (state, action) => ({
            ...state,
            loggedIn: true,
            status: Status.INIT,
            user: action.user,
        })
    ),
    on(authActions.registerfailure, authActions.loginfailure, (state) => ({
        ...state,
        status: Status.INIT,
    }))
);
